import React from 'react';
import { Box, Typography, Button, Stack, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo.png';
import { Link as RouterLink } from 'react-router-dom';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: '90vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 4, sm: 8 }
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={4} alignItems="center" textAlign="center">
          <img src={logo} alt="WebbEkonomi Logo" style={{ height: 300 }} />

          <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
            {t('homepage.title')}
          </Typography>

          <Typography variant="h6">{t('homepage.subtitle')}</Typography>

          <Box>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li>✔ {t('homepage.bullet1')}</li>
              <li>✔ {t('homepage.bullet2')}</li>
              <li>✔ {t('homepage.bullet3')}</li>
            </ul>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 2 }}>
            <Button
              component={RouterLink}
              to="/services-overview"
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: 'bold' }}
            >
              {t("homepage.services")}
            </Button>


            <Button
              component={RouterLink}
              to="/contact"
              variant="contained"
              color="primary"
              size="large"
              sx={{ fontWeight: 'bold' }}
            >
              {t('homepage.contact')}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default HomePage;
